module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title59"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429949880_tp01",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_copyrightNotice",
    attrs: {
      "href": "#/e9781429949880_notice",
      "id": "Notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_epigraphPage",
    attrs: {
      "href": "#/e9781429949880_epi01",
      "id": "toctitle61"
    }
  }, [_c('span', [_vm._v("Epigraph")])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("One")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c02",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Two")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c03",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Three")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c04",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Four")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c05",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Five")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c06",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Six")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c07",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Seven")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c08",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Eight")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c09",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Nine")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Ten")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c11",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Eleven")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twelve")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fourteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c15",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fifteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c16",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Sixteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Seventeen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Eighteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Nineteen")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-one")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-two")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-three")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c24",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-four")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c25",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-five")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c26",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-six")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c27",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-seven")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c28",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-eight")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c29",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Twenty-nine")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c30",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c31",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-one")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c32",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-two")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c33",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-three")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c34",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-four")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c35",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-five")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c36",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-six")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c37",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-seven")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c38",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-eight")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c39",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thirty-nine")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c40",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c41",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-one")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c42",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-two")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c43",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-three")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c44",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-four")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c45",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-five")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c46",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-six")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c47",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-seven")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c48",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-eight")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c49",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Forty-nine")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c50",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fifty")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c51",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fifty-one")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429949880_c52",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Fifty-two")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429949880_bm01",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Epilog")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429949880_als01",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TOR BOOKS BY BLAKE CHARLTON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429949880_ack01",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429949880_ata01",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429949880_cop01",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69218c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429949880_toc01.vue
// module id = 66
// module chunks = 0